import { render, staticRenderFns } from "./IssueRegist.vue?vue&type=template&id=8e5d479e&"
import script from "./IssueRegist.vue?vue&type=script&lang=js&"
export * from "./IssueRegist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports